import { Validator } from 'vee-validate'

const formFieldMixin = () => {
  return {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      error: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        name: '',
        rules: ''
      }
    },
    methods: {
      getValue () {
        return this.value
      },
      handleFocus () {
        this.isFocussed = true
        this.$emit('focus')
      },
      handleBlur (e) {
        this.name = e.target.getAttribute('name')
        this.rules = e.target.getAttribute('rules')
        this.value = e.target.value
        setTimeout(() => {
          this.isFocussed = false
          this.validate()
          this.$emit('blur')
        }, 10)
      },
      validate () {
        if (!this.rules) {
          return Promise.resolve({ [this.name]: this.value })
        }

        return new Promise((resolve, reject) => {
          const validator = new Validator({ [this.name]: this.rules })
          const fieldData = { [this.name]: this.getValue() }

          validator.validateAll(fieldData).then((valid) => {
            if (!valid) {
              this.hasError = true
              this.errorMessage = validator.errors.first(this.name)
              reject(validator.errors.first(this.name))
            } else {
              this.hasError = false
              this.errorMessage = ''
              resolve(fieldData)
            }
          })
            .catch((error) => {
              this.hasError = true
              this.errorMessage = validator.errors.first(this.name)
              this.$emit('error', new Error(`${error}`))
              return error
            })
        })
      }
    }
  }
}

export default formFieldMixin()
